import React from 'react';
import {Grid} from '@mui/material';
import AutoField from '../../../components/AutoForm/AutoFieldNew';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {useIsMinor} from '../hooks/createBuilderHooks';
import useComboFrequency from '../../../hooks/useComboFrequency';
import {shouldShowEmployerContribution} from './BuilderContributeHelpers';
import {
  ContributePersonalSingleGrossField,
  ContributePersonalSingleNetField,
  ContributePersonalRecurringGrossField,
  ContributePersonalRecurringNetField,
  ContributeEmployerSingleField,
  ContributeEmployerRecurringField,
} from './builderContributeFields';

export const BuilderContributeAmounts: React.FC<{disabled?: boolean}> = ({
  disabled = false,
}) => {
  const {values} = useAutoForm<builderFieldsType>();
  const isMinor = useIsMinor();
  const {hasSingle, hasRecurring} = useComboFrequency(values.contribute?.comboFrequency);
  const isPension = values.mainPlanType === 'pension';
  const showEmployer = shouldShowEmployerContribution({
    isMinor,
    mainPlanType: values.mainPlanType,
  });

  return (
    <Grid container spacing={3}>
      {hasSingle && (
        <Grid item xs={6}>
          <AutoField field={{...ContributePersonalSingleGrossField, disabled}} />
        </Grid>
      )}
      {hasSingle && isPension && (
        <Grid item xs={6}>
          <AutoField field={{...ContributePersonalSingleNetField, disabled: true}} />
        </Grid>
      )}
      {hasRecurring && (
        <Grid item xs={6}>
          <AutoField field={{...ContributePersonalRecurringGrossField, disabled}} />
        </Grid>
      )}
      {hasRecurring && isPension && (
        <Grid item xs={6}>
          <AutoField field={{...ContributePersonalRecurringNetField, disabled: true}} />
        </Grid>
      )}
      {showEmployer && hasSingle && (
        <Grid item xs={6}>
          <AutoField field={{...ContributeEmployerSingleField, disabled}} />
        </Grid>
      )}
      {showEmployer && hasRecurring && (
        <Grid item xs={6}>
          <AutoField field={{...ContributeEmployerRecurringField, disabled}} />
        </Grid>
      )}
    </Grid>
  );
};
